import styled from 'styled-components';

export const Hero = styled.div`
    padding: 10px 50px;
    margin: 175px 20px;
    color: #313131;
    display: flex;
    flex-direction: column;

    @media screen and (max-width: 768px) {
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: 0.8rem;
      margin: 140px 20px;
      /* margin: 40px 20px; */
      /* width: clamp(350px, 90%, 550px); */
  }
`;
export const Container = styled.div`
    align-items: center;
    justify-content: center;
    position: absolute;
`;

export const Sub = styled.p`
    font-size: clamp(2em, 30% ,5.5em);
    font-weight: 100;
    letter-spacing: 6px;
    width: clamp(25rem, 60%, 35rem);
`;
export const Head = styled.h1`
    padding: 0.5rem 0;
    /* font-size: clamp(3.5em, 30% ,5.5em); */
    font-weight: 700;
    letter-spacing: 12px;
    @media screen and (max-width: 768px) {
        letter-spacing: 8px;
  }
`;
export const Para = styled.p`
        padding: 1rem 0;
        font-size: clamp(1.2em, 90% ,5em);
        letter-spacing: 2px;
        line-height: 1.8rem;
        width: 50vw;
        @media screen and (max-width: 768px) {
            font-size: clamp(1em, 50% ,5em);
            line-height: 1.5rem;
            width: 17rem;
  }
`;
export const Button = styled.button`
    padding: 0.8rem 2.5rem;
    margin: 1.5rem 0 0 0;
    background: #CE1212;
    color: #fff;
    font-size: 1.1rem;
    font-weight: 400;
    border: none;
    cursor: pointer;
    width: 15rem;
    &.contact{
        /* box-sizing: border-box; */
        background: transparent;
        color: #313131;
        border: 3px solid #d62727;
    }
    @media screen and (max-width: 768px) {
        /* font-size: clamp(1.3em, 30% ,2em); */
        /* width: clamp(60vw, 50%, 100vw); */
        /* margin: 1.5rem 0 0 0; */
        /* text-align: center; */
  }
  @media screen and (max-width: 1168px) {
        /* margin: 1rem 0 0 0; */

  }
`;

export const Design = styled.img`
    height: 100%;
    width: clamp(100px, 35%, 800px);
    object-fit: cover;
    position: absolute;
    right: 0;
    top:0;
    /* display: none; */

@media screen and (max-width: 1168px) {
    /* display: none; */
    width: clamp(100px, 15%, 800px);
  }
@media screen and (max-width: 768px) {
      display: none;
  }
`;